import { put, select, takeLatest } from 'redux-saga/effects'

import {
  fetchUsersByStatus,
  fetchUsersByStatusTrigger, // @ts-ignore
} from 'store/entities/organizations/actions'
import {
  getOrganizationUsersOrganizationId,
  getOrganizationUsersFilterByTeam,
  getOrganizationUsersTab,
  getOrganizationUsersFilterBy, // @ts-ignore
} from 'store/entities/organizations/selectors'
// @ts-ignore
import { getIdentityOrganizationId, isAdmin } from 'store/entities/identity/selectors'

export default function* fetchUsersByStatusSaga() {
  yield takeLatest(fetchUsersByStatusTrigger.toString(), fetchUsersByStatusFlow)
}

export function* fetchUsersByStatusFlow() {
  let id
  const admin = yield select(isAdmin)
  if (admin) {
    id = yield select(getIdentityOrganizationId)
  } else {
    id = yield select(getOrganizationUsersOrganizationId)
  }
  const team = yield select(getOrganizationUsersFilterByTeam)
  // slice(0, -1) for delete plurals at tab name
  const tabType = (yield select(getOrganizationUsersTab)).slice(0, -1)
  const search = yield select(getOrganizationUsersFilterBy)
  try {
    yield put(fetchUsersByStatus({ id, team, tabType, search }))
  } catch (badResponse) {
    console.log(badResponse)
  }
}
